import React from "react";
import Hero from "./components/Hero";
import FeatureCards from "./components/FeatureCards";
import ComparisonSection from "./components/ComparisonSection";
import CtaSection from "./components/CtaSection";
import NoticePopup from "./components/NoticePopup";
import "./App.css";

const App: React.FC = () => {
  return (
    <div className="App min-h-screen bg-gradient-to-br from-blue-50 to-blue-100">
      <NoticePopup />
      <Hero />
      <FeatureCards />
      <ComparisonSection />
      <CtaSection />
    </div>
  );
};

export default App;
